export const SET_GUIDE_PROPERTY = 'SET_GUIDE_PROPERTY';
export const GET_DRIVER_GUIDE = 'GET_DRIVER_GUIDE';
